import { CheckCircle, ExternalLink, ShieldCheck } from "lucide-react";

export default function GoogleConnectStep({
  onBack,
  onSkip,
  onConnect,
  loading,
  error,
}) {
  return (
    <div className="space-y-6">
      {error && (
        <div className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
          {error}
        </div>
      )}

      <div className="rounded-2xl border border-slate-200 bg-slate-50 p-5">
        <div className="flex items-start gap-4">
          <div className="h-12 w-12 rounded-xl bg-indigo-100 text-indigo-600 flex items-center justify-center shrink-0">
            <ShieldCheck size={22} />
          </div>

          <div>
            <h3 className="font-semibold text-slate-900">
              Connect Google Business Profile
            </h3>

            <p className="text-sm text-slate-600 mt-2 leading-relaxed">
              Connecting Google will allow RevUShield to sync reviews and
              prepare response suggestions for approval.
            </p>
          </div>
        </div>
      </div>

      <div className="space-y-3">
        {[
          "Sync new Google reviews",
          "Generate suggested owner responses",
          "Approve, edit, or reject responses before posting",
        ].map((item) => (
          <div key={item} className="flex items-start gap-3">
            <CheckCircle size={18} className="text-green-600 mt-0.5" />
            <p className="text-sm text-slate-700">{item}</p>
          </div>
        ))}
      </div>

      <div className="rounded-2xl border border-amber-200 bg-amber-50 p-4">
        <p className="text-sm text-amber-800">
          You can skip this for now and connect Google later from Settings.
        </p>
      </div>

      <div className="flex flex-col sm:flex-row gap-3 pt-2">
        <button
          type="button"
          onClick={onBack}
          className="w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm font-medium text-slate-700 hover:bg-slate-50 transition"
        >
          Back
        </button>

        <button
          type="button"
          onClick={onSkip}
          className="w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm font-medium text-slate-700 hover:bg-slate-50 transition"
        >
          Skip for now
        </button>

        <button
          type="button"
          onClick={onConnect}
          disabled={loading}
          className="w-full rounded-xl bg-indigo-600 px-4 py-3 text-sm font-medium text-white hover:bg-indigo-700 disabled:opacity-60 disabled:cursor-not-allowed transition inline-flex items-center justify-center gap-2"
        >
          Connect Google
          <ExternalLink size={16} />
        </button>
      </div>
    </div>
  );
}
